import { FC, SVGAttributes } from 'react';

const StateErrorSolid: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="current" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9996 2.59961C6.53199 2.59961 2.09961 7.03199 2.09961 12.4996C2.09961 17.9672 6.53199 22.3996 11.9996 22.3996C17.4672 22.3996 21.8996 17.9672 21.8996 12.4996C21.8996 7.03199 17.4672 2.59961 11.9996 2.59961ZM10.7306 8.15043C10.6552 7.39697 11.2469 6.74316 12.0041 6.74316C12.7614 6.74316 13.353 7.39697 13.2777 8.15043L12.7816 12.7964C12.7417 13.1958 12.4056 13.5 12.0041 13.5C11.6027 13.5 11.2666 13.1958 11.2266 12.7964L10.7306 8.15043ZM10.5898 16.6432C10.5898 15.8621 11.223 15.2289 12.0041 15.2289C12.7852 15.2289 13.4184 15.8621 13.4184 16.6432C13.4184 17.4243 12.7852 18.0574 12.0041 18.0574C11.223 18.0574 10.5898 17.4243 10.5898 16.6432Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default StateErrorSolid;
